// oxlint-disable require-await
import {dialog} from '@cypro/ui/components'
import {DeleteResourceDialog} from '@cypro/ui/components'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeleteWard() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.wards.deleteBatch({wardIds: [payload.id]}), async ({server}) => {
        const result = await server
        return result
      }),
    [zero]
  )
}

export function useConfirmDeleteWard() {
  const {t: tWards} = useTranslate('wards')
  const deleteWard = useDeleteWard()

  return useCallback(
    async (payload: DeleteResourceSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={tWards('delete_ward_dialog.title')}
            description={tWards('delete_ward_dialog.description')}
          />
        ),
      })
      if (!confirmed) throw new Error('User did not confirm')

      const deleteRes = await deleteWard(payload)
      if (!deleteRes) throw new Error('Unexpected error')
      if (deleteRes.type === 'error') throw deleteRes.error
    },
    [tWards, deleteWard]
  )
}
